import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SaveEventUserDto, insertEventUserAsync } from './AddEventUserAPI'
import { RootState } from '../../app/store';
import { CurrentPartyEventState } from '../currentPartyEvent/currentPartyEventSlice'
import { EventUser } from '../../model/EventUser'
import { sanitizeEmail } from '../../utils/emailUtils';


export interface CurrentEventUserState {
    userEmail: string
    alias: string
    status: 'idle' | 'loading' | 'failed'
}

const initialState: CurrentEventUserState = {
    userEmail: '',
    alias: '',
    status: 'idle' 
}

export interface SaveEventUserRequest {
    token: string
  }

  export const addEventUserAsync = createAsyncThunk(
    'currentEventUser/addEventUser',
    async (request: SaveEventUserRequest , { getState }) => {
      const { currentEventUser } = getState() as { currentEventUser: CurrentEventUserState}
      const { currentPartyEvent } = getState() as { currentPartyEvent: CurrentPartyEventState}
      let savePartyEventDto: SaveEventUserDto = {
        partyEventId: currentPartyEvent.partyEvent?.id ??0,
        email: currentEventUser.userEmail,
        alias: currentEventUser.alias,
        attendingStatus: 0
      }
      const response = await insertEventUserAsync(savePartyEventDto, request.token)
      if (response === true) {
          return  {
            admin: false,
            email: currentEventUser.userEmail,
            alias: currentEventUser.alias,
            attendingStatus: 0
          } as EventUser
      }
      return null;
    }
  )

  export const currentEventUserSlice = createSlice({
    name: 'currentEventUser',
    initialState: initialState,
    reducers: {
       
        setUserEmail: (state, action: PayloadAction<string>) => {
          state.userEmail = sanitizeEmail(action.payload)
        },
        
        setAlias: (state, action: PayloadAction<string>) => {
          state.alias = action.payload
        }
      
    },
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: (builder) => {
      builder
        .addCase(addEventUserAsync.pending, (state) => {
          state.status = 'loading';
        })
        .addCase(addEventUserAsync.fulfilled, (state, action) => {
          state.status = 'idle';
          
        })
        .addCase(addEventUserAsync.rejected, (state) => {
          state.status = 'failed';
        });
    },
})

  export const selectCurrentEventUserStatus = (state: RootState) => state.currentEventUser.status;
  export const selectCurrentEventUserAlias = (state: RootState) => state.currentEventUser.alias;
  export const selectCurrentEventUserEmail = (state: RootState) => state.currentEventUser.userEmail;
  export const { setAlias, setUserEmail } = currentEventUserSlice.actions


  export default currentEventUserSlice.reducer